import { useLocalZonePreference } from '@/hooks/useLocalZonePreference';
import { Source } from '@/types/evals';
import { formatTimestamp } from '@/utils/timeFormatter';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';
import styles from './SourceDetailsTab.module.scss';

type Props = {
  source: Source;
};

export function SourceDetailsTab( { source }: Props ) {
  const [ useLocalZone ] = useLocalZonePreference();

  return (
    <section
      className={ styles.container }
      data-deprecated={ source.is_deprecated ? 'true' : undefined }
      data-testid="source-details-tab"
    >
      <h3 className={ styles.heading }>General Properties</h3>
      <InfoCardRow>
        <InfoCard label="Source id" value={ source.id } />
        <InfoCard label="Created by" value={ source.created_by ?? '—' } />
        <InfoCard label="Created" value={ formatTimestamp( source.created_at, useLocalZone ) } />
        <InfoCard label="Last Updated" value={ formatTimestamp( source.updated_at, useLocalZone ) } />
      </InfoCardRow>
    </section>
  );
}
